const Border = props => {
    return <div className="container fluid py-2" id="border">
        <div className="container fluid">
            <p className="text xl"><a href="#border" className="link">&#128279;</a> Border</p>
            <p className="text md">
                Border styling class comes only in black for the time being, and is used for development
                mostly.
        </p>
        </div>

        <div className="spacer md"></div>
        <div className="row align-items-center">
            <div className="col md-III">
                <div className="container md">
                    <div className="table" cell-padding="2" head-padding="3" cell-spacing="1" cell-border="1"
                        table-striped="true" table-hover="true">
                        <table>
                            <thead>
                                <tr>
                                    <th>Class</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    onClick={() => props.helper('border-display', `<div class='border-dark' style='height: 100%;'></div>`, 'bg-light h25 p-2')}>
                                    <td>
                                        <code>.border-dark</code>
                                    </td>
                                    <td>Sets the border to 1px solid dark</td>
                                </tr>
                                <tr
                                    onClick={() => props.helper('border-display', `<div class='border-light' style='height: 100%;'></div>`, 'bg-dark h25 p-2')}>
                                    <td>
                                        <code>.border-light</code>
                                    </td>
                                    <td>Sets the border to 1px solid light</td>
                                </tr>
                                <tr
                                    onClick={() => props.helper('border-display', `<p class='text lg border-underline-dark'>text</p>`, 'bg-light h25 p-2')}>
                                    <td>
                                        <code>.border-underline-dark</code>
                                    </td>
                                    <td>Sets the border-bottom to 1px solid light</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="col md-III">
                <div className="container sm">
                    <div className="h25 p-2" id="border-display">
                        <div className="border-dark" style={{ height: '100%' }}></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default Border